import styled from '@emotion/styled';
import {tokens} from '../../../public/tokens';
import Skeleton from "react-loading-skeleton";
import React from "react";

export const Card = styled('div')`
  padding: ${({padding}) => padding || tokens.globals['spacing-sm']};
  background: ${tokens.colors.surfaces["container-background"]};
  border: 1px solid ${tokens.colors.surfaces["border-divider"]};
  box-shadow: ${tokens.effects.effects.shadow.default};
  border-radius: ${tokens.globals["border-radius"]};
  display: flex;
  flex-direction: ${({flexDirection}) => flexDirection ?? "column"};
  align-items: ${({alignItems}) => alignItems ?? "center"};
  text-align : ${({textAlign}) => textAlign ?? "center"};
  cursor : ${({noAction}) => noAction ? "default" : "pointer"};
  gap: ${({ gap }) => gap ?? "0px"};
  height: 100%;
  justify-content: ${({ justifyContent }) => justifyContent ?? "center"};

  ${({ $position }) =>
    $position && `position: ${$position};`}

  &:hover {
    box-shadow: ${({noAction}) => noAction ? tokens.effects.effects.shadow.default : tokens.effects.effects.shadow.hover};
    background: ${({noAction}) => noAction ? "none" : tokens.colors.theme['hover-color']};
  }
  &:active {
    box-shadow: none;
    background: ${({noAction}) => noAction ? "transparent" : tokens.colors.theme['active-color']};
  }
  @media (max-width: 567px) {
    padding: ${({ mobilePadding }) => mobilePadding || tokens.globals['spacing-sm']};
  }
`;



const SkeletonWrapper = styled("div")`
  border: 1px solid ${tokens.colors.surfaces["border-divider"]};
  border-radius: ${tokens.globals["border-radius"]};
  overflow: hidden;
`;

export const CardSkeleton = () => {
  return (
    <ul className='card-grid re-registration-ul-list list-unstyled'>
      {Array(4)
        .fill()
        .map((_, index) => (
          <li key={index}>
            <SkeletonWrapper>
              <Skeleton width="100%" height={252} />
            </SkeletonWrapper>
          </li>
        ))}
    </ul>
  );
};
